import { c as _c } from "react/compiler-runtime";
import { IcoDotSmall16 } from '@onefootprint/icons';
import { cx } from 'class-variance-authority';
import type React from 'react';
import TimelineItemTime from '@/components/timeline-item-time';
import type { TimelineItem } from '../../timeline';
const HEADER_HEIGHT = '32px';

// Shared so the loading skeleton mirrors the row grid without drifting. Phones have no time column; the
// time goes under the event title.
export const TIMELINE_GRID = 'grid-cols-[24px_minmax(0,1fr)] md:grid-cols-[160px_24px_1fr]';
export const TIMELINE_GRID_TIME_ONLY = 'grid-cols-[24px_minmax(0,1fr)] md:grid-cols-[96px_24px_1fr]';
export const TIMELINE_GRID_AREAS = "[grid-template-areas:'icon_content'_'line_content'] md:[grid-template-areas:'time_icon_content'_'empty_line_content'_'empty_line_content']";
type TimelineItemRowProps = {
  item: TimelineItem;
  i: number;
  allItems: TimelineItem[];
  children?: React.ReactNode;
  onMouseOver?: () => void;
  onMouseLeave?: () => void;
  showViewOnboardingButton?: boolean;
  onViewOnboardingButtonClick?: () => void;
  rightActions?: React.ReactNode;
  timeOnly?: boolean;
  hideConnector?: boolean;
};
const TimelineItemRow = t0 => {
  const $ = _c(51);
  const {
    item,
    i,
    allItems,
    children,
    onMouseOver,
    onMouseLeave,
    rightActions,
    timeOnly,
    hideConnector
  } = t0;
  const {
    iconComponent,
    headerComponent,
    bodyComponent
  } = item;
  const last = i === allItems.length - 1;
  const nextIsPagination = allItems[i + 1]?.iconComponent === null;
  let t1;
  if ($[0] !== onMouseOver) {
    t1 = event => {
      if (event.pointerType === "mouse") {
        onMouseOver?.();
      }
    };
    $[0] = onMouseOver;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handlePointerEnter = t1;
  let t2;
  if ($[2] !== onMouseLeave) {
    t2 = event_0 => {
      if (event_0.pointerType === "mouse") {
        onMouseLeave?.();
      }
    };
    $[2] = onMouseLeave;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const handlePointerLeave = t2;
  const t3 = timeOnly ? TIMELINE_GRID_TIME_ONLY : TIMELINE_GRID;
  let t4;
  if ($[4] !== t3) {
    t4 = cx("group relative grid h-auto grid-rows-[24px_auto] md:grid-rows-[32px_auto]", t3, TIMELINE_GRID_AREAS);
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const t5 = !timeOnly && "pl-3";
  let t6;
  if ($[6] !== t5) {
    t6 = cx("hidden h-8 items-center md:flex", t5);
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      gridArea: "time"
    };
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== item.timestamp || $[10] !== timeOnly) {
    t8 = item.timestamp && <TimelineItemTime timestamp={item.timestamp} timeOnly={timeOnly} />;
    $[9] = item.timestamp;
    $[10] = timeOnly;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t6 || $[13] !== t8) {
    t9 = <div className={t6} style={t7}>{t8}</div>;
    $[12] = t6;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== hideConnector || $[16] !== last || $[17] !== nextIsPagination) {
    t10 = !last && !hideConnector && <div data-testid="timeline-item-connector" className="absolute top-0 bottom-0 left-1/2 -translate-x-1/2 w-[2px]" style={{
      gridArea: "line",
      height: nextIsPagination ? `calc(100% + ${HEADER_HEIGHT} / 2)` : "100%",
      background: nextIsPagination ? "linear-gradient(to bottom, var(--border-color-primary), transparent)" : "var(--border-color-primary)"
    }} />;
    $[15] = hideConnector;
    $[16] = last;
    $[17] = nextIsPagination;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = {
      gridArea: "icon"
    };
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== iconComponent) {
    t12 = iconComponent === undefined ? <IcoDotSmall16 /> : iconComponent;
    $[20] = iconComponent;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== t12) {
    t13 = <div className="flex items-center justify-center min-h-6 md:min-h-8" style={t11}>{t12}</div>;
    $[22] = t12;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = {
      gridArea: "content",
      gridTemplateAreas: "\"header\" \"body\"",
      gridTemplateColumns: "1fr",
      gridTemplateRows: "auto"
    };
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  let t15;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = {
      gridArea: "header"
    };
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  let t16;
  if ($[26] !== headerComponent) {
    t16 = <div className="flex flex-wrap items-center justify-start gap-2 flex-1 w-full md:flex-nowrap md:w-auto">{headerComponent}</div>;
    $[26] = headerComponent;
    $[27] = t16;
  } else {
    t16 = $[27];
  }
  let t17;
  if ($[28] !== item.timestamp || $[29] !== timeOnly) {
    t17 = item.timestamp && <div className="md:hidden"><TimelineItemTime timestamp={item.timestamp} timeOnly={timeOnly} /></div>;
    $[28] = item.timestamp;
    $[29] = timeOnly;
    $[30] = t17;
  } else {
    t17 = $[30];
  }
  let t18;
  if ($[31] !== rightActions || $[32] !== t16 || $[33] !== t17) {
    t18 = <div className="flex flex-col items-start justify-center gap-1 mt-0 min-h-6 pr-2 md:flex-row md:items-center md:justify-normal md:gap-0 md:min-h-8" style={t15}>{t16}{t17}{rightActions}</div>;
    $[31] = rightActions;
    $[32] = t16;
    $[33] = t17;
    $[34] = t18;
  } else {
    t18 = $[34];
  }
  let t19;
  if ($[35] !== bodyComponent) {
    t19 = bodyComponent ? <div className="flex flex-col gap-2 w-full pb-7 pl-3" style={{
      gridArea: "body"
    }}>{bodyComponent}</div> : <span className="h-1" />;
    $[35] = bodyComponent;
    $[36] = t19;
  } else {
    t19 = $[36];
  }
  let t20;
  if ($[37] !== t18 || $[38] !== t19) {
    t20 = <div className="grid pl-2 gap-2" style={t14}>{t18}{t19}</div>;
    $[37] = t18;
    $[38] = t19;
    $[39] = t20;
  } else {
    t20 = $[39];
  }
  let t21;
  if ($[40] !== children || $[41] !== handlePointerEnter || $[42] !== handlePointerLeave || $[43] !== onMouseLeave || $[44] !== onMouseOver || $[45] !== t10 || $[46] !== t13 || $[47] !== t20 || $[48] !== t4 || $[49] !== t9) {
    t21 = <div className={t4} onPointerEnter={handlePointerEnter} onPointerLeave={handlePointerLeave} onFocus={onMouseOver} onBlur={onMouseLeave}>{children}{t9}{t10}{t13}{t20}</div>;
    $[40] = children;
    $[41] = handlePointerEnter;
    $[42] = handlePointerLeave;
    $[43] = onMouseLeave;
    $[44] = onMouseOver;
    $[45] = t10;
    $[46] = t13;
    $[47] = t20;
    $[48] = t4;
    $[49] = t9;
    $[50] = t21;
  } else {
    t21 = $[50];
  }
  return t21;
};
export default TimelineItemRow;